var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({staticClass:"quiz-grid-item"},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.iconUrl)?_c('i',{staticClass:"quiz-grid-item__icon",style:(_vm.iconStyle)}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }